import { InjectionToken } from '@angular/core';

export const LOGOS = new InjectionToken<string>('Token for logos', {
    factory: () => 'ridango',
});
